import { graphql } from 'relay-runtime';

const ServicePage = graphql`
  query ServicePageQuery($slug: String!, $url: String!, $username: String!) {
    productizedServiceBySlug(slug: $slug) {
      id
      analyticsId
      slug
      title
      blocknoteContent
      visitorCanEdit
      portfolioProjects {
        edges {
          node {
            id
            title
            slug
            cover {
              ... on PortfolioProjectImageCover {
                __typename
                image {
                  id
                  animated
                  height
                  originalFormat
                  sizeBytes
                  uid
                  width
                }
              }
              ... on PortfolioProjectTextCover {
                __typename
                style
              }
            }
          }
        }
      }
      deliverables {
        edges {
          node {
            id
            createdAt
            description
            sortOrder
            title
          }
        }
      }
      price {
        type
        interval
        amount
        timeline
      }
      roles {
        edges {
          node {
            id
            name
          }
        }
      }
      tools {
        edges {
          node {
            id
            name
            logoImage {
              id
              uid
            }
          }
        }
      }
      userProfile {
        id
        displayUsername
        firstName
        lastName
        generalInquiryCtaIsVisible
        portfolioProjects(type: PROJECT, excludeDrafts: true) {
          edges {
            node {
              id
            }
          }
        }
        externalLinks {
          edges {
            node {
              id
              label
              url
              socialMediaSite {
                nid
              }
            }
          }
        }
        ...Services_userProfile
        ...Footer_userProfile
      }
      ...Service_productizedService
    }
    userProfileByUsername(username: $username) {
      id
      ...UserProfile_userProfile
    }
    ...UrlMetaData_queryFragment
    ...IndependentPortfolioTemplates_queryFragment
  }
`;

export default ServicePage;
